/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_CrumbInputs */

const en_contact_crumb = /** @type {(inputs: Contact_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Contact_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_crumb = /** @type {((inputs?: Contact_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_crumb(inputs)
});